const clampOpacity = (value) => Math.min(Math.max(value, 0), 1)

export const SWIPE_SIDE_LEFT = 'left'
export const SWIPE_SIDE_RIGHT = 'right'

export const getComparisonMapComposition = ({baseAsset, compareAsset, compareOpacityPercent}) => {
  if (!baseAsset || !compareAsset) {
    return {isRenderable: false}
  }

  const baseIsGoogleMap = Boolean(baseAsset.isGoogleMap)
  const compareIsGoogleMap = Boolean(compareAsset.isGoogleMap)

  if (baseIsGoogleMap && compareIsGoogleMap) {
    return {
      backgroundAsset: null,
      isRenderable: true,
      overlayAsset: null,
      overlayOpacity: 0,
      swipeSide: SWIPE_SIDE_RIGHT,
    }
  }

  if (compareIsGoogleMap) {
    return {
      backgroundAsset: null,
      isRenderable: Boolean(baseAsset.canvas),
      overlayAsset: baseAsset,
      overlayOpacity: clampOpacity(1 - compareOpacityPercent / 100),
      swipeSide: SWIPE_SIDE_LEFT,
    }
  }

  return {
    backgroundAsset: baseIsGoogleMap ? null : baseAsset,
    isRenderable: Boolean(compareAsset.canvas) && (baseIsGoogleMap || Boolean(baseAsset.canvas)),
    overlayAsset: compareAsset,
    overlayOpacity: clampOpacity(compareOpacityPercent / 100),
    swipeSide: SWIPE_SIDE_RIGHT,
  }
}
